export var IncomeTypesPayg;
(function (IncomeTypesPayg) {
    IncomeTypesPayg["BaseSalary"] = "PAYG_BASE_SALARY";
    IncomeTypesPayg["CommissionIncome"] = "PAYG_COMMISSION_INCOME";
    IncomeTypesPayg["BonusIncome"] = "PAYG_BONUS_INCOME";
    IncomeTypesPayg["OvertimeIncome"] = "PAYG_OVERTIME_INCOME";
    IncomeTypesPayg["CarAllowance"] = "PAYG_CAR_ALLOWANCE";
    IncomeTypesPayg["AllowancesTaxed"] = "PAYG_ALLOWANCES_TAXED";
    IncomeTypesPayg["AllowancesNotTaxed"] = "PAYG_ALLOWANCES_NOT_TAXED";
    IncomeTypesPayg["CompanyCar"] = "PAYG_COMPANY_CAR";
    IncomeTypesPayg["NonVoluntaryDeductionsPreTax"] = "PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX";
    IncomeTypesPayg["SalarySacrifice"] = "PAYG_SALARY_SACRIFICE";
})(IncomeTypesPayg || (IncomeTypesPayg = {}));
//# sourceMappingURL=IncomeTypesPayg.js.map